import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import {
  LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED,
  LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED,
  UX_FEEDBACK_DESKTOP_EVENT_NAME,
  UX_FEEDBACK_MOBILE_EVENT_NAME,
} from './constants';
import {
  getLocalStorageFiltersIsExpired,
  getLocalStorageFiltersPollWasShow,
  getLocalStorageFiltersWereAppliedTwoTimes,
  removeLocalStorageFiltersWereApplied,
  setLocalStorageFiltersPollWasShow,
} from './localStorageUtils';
import { sendUXSEvent } from '../../utils/uxs';

export function useFiltersUxfbPoll() {
  const deviceType = useDeviceType();

  const { key, uxFeedbackEventName } = React.useMemo(() => {
    const isMobile = deviceType !== 'desktop';

    return {
      key: isMobile ? LOCAL_STORAGE_IS_MOBILE_FILTERS_WERE_APPLIED : LOCAL_STORAGE_IS_DESKTOP_FILTERS_WERE_APPLIED,
      uxFeedbackEventName: isMobile ? UX_FEEDBACK_MOBILE_EVENT_NAME : UX_FEEDBACK_DESKTOP_EVENT_NAME,
    };
  }, [deviceType]);

  const isExpired = getLocalStorageFiltersIsExpired(key);
  const wereAppliedTwoTimes = getLocalStorageFiltersWereAppliedTwoTimes(key);
  const isShown = getLocalStorageFiltersPollWasShow(key);

  React.useEffect(() => {
    //Удаляем значение из LS через 7 дней
    if (isExpired) {
      removeLocalStorageFiltersWereApplied(key);

      return;
    }

    let timeoutId: NodeJS.Timeout;

    if (wereAppliedTwoTimes && !isShown) {
      timeoutId = setTimeout(() => {
        sendUXSEvent(uxFeedbackEventName);
        setLocalStorageFiltersPollWasShow(key);
      }, 3000);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isExpired, wereAppliedTwoTimes, isShown]);
}
